import {
  Box,
  Button,
  Chip,
  Container,
  Stack,
  Theme,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import styled from "styled-components";
import AsideCard from "../Components/AsideCard";
import ContactCTASection from "../Components/ContactCTASection";
import {
  aboutCards,
  advantageCards,
  capabilityCards,
  ourWorkProjects,
  processCards,
} from "../Components/Content/OnePagerCopy";
import Footer from "../Components/Footer";
import HeadlineSection from "../Components/HeadlineSection";
import CapabilitiesSection from "../Components/Home/CapabilitiesSection";
import Hero from "../Components/Home/Hero";
import { OurWorkSection } from "../Components/Home/OurWorkSection";
import TestimonialsSection from "../Components/Home/TestimonialsSection";
import PageSectionBG from "../Components/PageSectionBG";
import { PageShell } from "../Components/PageShell";
import { BlackHole } from "../Components/Scenes/BlackHole";
import { Globe } from "../Components/Scenes/Globe";
import { Rings } from "../Components/Scenes/Rings";
import SectionTitle from "../Components/SectionTitle";
import { HubspotForm } from "./Contact";

const OnePager = () => {
  // const touchscreen = isTouchDevice();
  const theme = useTheme();

  const showOldSections = false;

  return (
    <PageShell>
      <Hero />

      <PageSectionBG
        bgcolor={"transparent"}
        id="black-hole-section"
        paddingBottom={0}
        paddingTop={0}
      >
        <Stack
          sx={{
            height: { xs: "45vh", sm: "50vh", md: "60vh" },
            width: "100%",
          }}
        >
          <BlackHole />
        </Stack>
      </PageSectionBG>

      <PageSectionBG
        bgcolor={"transparent"}
        id="who-we-are-section"
        paddingBottom={13}
        paddingTop={14}
      >
        <Container maxWidth="xl">
          <Stack
            justifyContent={"start"}
            direction={"column"}
            alignItems={"start"}
            width={"100%"}
            gap={{
              xs: 4,
              sm: 5,
              md: 7,
            }}
          >
            <SectionTitle label="001 -- About" title="Who We Are" id="about" />

            <Stack
              justifyContent={"start"}
              alignItems={"start"}
              direction={{
                xs: "column",
                md: "row",
              }}
              width={"100%"}
              pb={{ xs: 12, md: 24 }}
              gap={{
                xs: 4,
                sm: 6,
                md: 14,
              }}
            >
              {aboutCards.map(({ title, description }, index) => (
                <AsideCard
                  key={index}
                  flex={1}
                  bgcolor="dark"
                  content={[title, description]}
                />
              ))}
            </Stack>

            <SectionTitle
              label="002 -- What we can do"
              title="Capabilities"
              id="capabilities"
            />

            <Stack
              justifyContent={"start"}
              alignItems={"start"}
              direction={"column"}
              width={"100%"}
              gap={1.5}
              pb={1}
            >
              <Typography
                color={theme.palette.common.white}
                fontWeight={700}
                variant="h5"
              >
                Product Development and Delivery
              </Typography>
              <Typography
                color={theme.palette.common.white}
                fontWeight={200}
                variant="h6"
                sx={{
                  lineHeight: 1.8,
                  width: {
                    xs: "85%",
                    md: "50%",
                  },
                }}
              >
                Transform your vision into reality with enterprise-grade
                expertise. We deliver end-to-end product development using
                proven methodologies that ensure exceptional results at every
                stage.
              </Typography>
            </Stack>

            <Stack
              justifyContent={"start"}
              alignItems={"start"}
              direction={{
                xs: "column",
                md: "row",
              }}
              width={"100%"}
              gap={{
                xs: 3,
                sm: 5,
                md: 12,
              }}
              pb={{ xs: 12, md: 24 }}
            >
              {capabilityCards.map(({ title, description }, index) => (
                <AsideCard
                  key={index}
                  flex={1}
                  showDivider
                  bgcolor="dark"
                  content={[title, description]}
                  style={{ minHeight: "7.5rem" }}
                />
              ))}
            </Stack>

            <SectionTitle label="003 -- Our advantage" title="Why choose us" />

            <Stack
              justifyContent={"start"}
              alignItems={"start"}
              direction={{
                xs: "column",
                md: "row",
              }}
              width={"100%"}
              gap={{
                xs: 4,
                sm: 6,
                md: 14,
              }}
              pt={2}
            >
              {advantageCards
                .slice(0, 2)
                .map(({ title, description }, index) => (
                  <AsideCard
                    key={index}
                    flex={1}
                    bgcolor="dark"
                    // animateInView
                    content={[title, description]}
                  />
                ))}
              <Stack
                sx={{
                  flex: 1,
                  display: { xs: "none", sm: "none", md: "block" },
                }}
              />
            </Stack>

            <Stack
              justifyContent={"start"}
              alignItems={"start"}
              direction={{
                xs: "column",
                md: "row",
              }}
              width={"100%"}
              gap={{
                xs: 4,
                sm: 6,
                md: 14,
              }}
              pt={{
                xs: 0,
                sm: 0,
                md: 2,
              }}
            >
              {advantageCards
                .slice(2, 4)
                .map(({ title, description }, index) => (
                  <AsideCard
                    key={index}
                    flex={1}
                    bgcolor="dark"
                    // animateInView
                    content={[title, description]}
                  />
                ))}
              <Stack
                sx={{
                  flex: 1,
                  display: { xs: "none", sm: "none", md: "block" },
                }}
              />
            </Stack>

            <Stack
              style={{ padding: "1rem 0 4rem" }}
              justifyContent="start"
              direction={{
                xs: "column",
                sm: "row",
              }}
              sx={{
                display: { xs: "none", sm: "none", md: "flex" },
              }}
              spacing={7}
              alignItems="center"
              width="100%"
            >
              <Typography
                variant="body2"
                color="#EEFF41"
                sx={{
                  textAlign: {
                    xs: "center",
                    sm: "left",
                  },
                  pt: {
                    xs: 3,
                    sm: 3,
                    md: 0,
                  },
                }}
              >
                Our team
                <br />
                has been trusted by
              </Typography>

              <img
                alt="Amazon"
                src={"/assets/brands/amazon.png"}
                height={28}
                loading="lazy"
                decoding="async"
              />
              <img
                alt="AWS"
                src={"/assets/brands/aws.png"}
                height={28}
                loading="lazy"
                decoding="async"
              />
              <img
                alt="Deloitte"
                src={"/assets/brands/deloitte.png"}
                height={28}
                loading="lazy"
                decoding="async"
              />
              <img
                alt="Microsoft"
                src={"/assets/brands/microsoft.png"}
                height={28}
                loading="lazy"
                decoding="async"
              />
            </Stack>
          </Stack>
        </Container>
      </PageSectionBG>

      <PageSectionBG
        bgcolor={"transparent"}
        id="globe-section"
        paddingBottom={0}
        paddingTop={0}
      >
        <Stack
          sx={{
            height: { xs: "32vh", sm: "40vh", md: "45vh" },
            width: "100%",
          }}
        >
          <Globe />
        </Stack>
      </PageSectionBG>

      <PageSectionBG
        sx={{
          borderRadius: {
            xs: "24px",
            sm: "24px",
            md: "48px",
          },
          position: "relative",
          minHeight: "90vh",
          zIndex: 1,
        }}
        bgcolor={theme.palette.tan.main}
        id="selected-projects-section"
        paddingBottom={
          useMediaQuery((theme: Theme) => theme.breakpoints.up("md")) ? 3 : 1
        }
        paddingTop={
          useMediaQuery((theme: Theme) => theme.breakpoints.up("md")) ? 10 : 4
        }
        mt={-8}
      >
        <Container
          maxWidth="xl"
          sx={{
            px: { xs: 3, sm: 3.5, md: 3 },
          }}
        >
          <Stack
            justifyContent={"start"}
            alignItems={"center"}
            direction={"column"}
            width={"100%"}
            gap={{
              xs: 4,
              sm: 5,
              md: 6,
            }}
          >
            <SectionTitle
              id="work"
              label="004 -- Work"
              title="Selected Projects"
              color={theme.palette.primary.main}
            />

            <Stack
              justifyContent={"start"}
              alignItems={"center"}
              direction={"column"}
              width={"100%"}
              gap={10}
            >
              {ourWorkProjects.map((project, index) => (
                <Stack
                  key={index}
                  justifyContent={"start"}
                  alignItems={"start"}
                  direction={"column"}
                  width={"100%"}
                  gap={0}
                >
                  <Stack
                    justifyContent={"start"}
                    alignItems={"start"}
                    direction={"column"}
                    width={"100%"}
                    gap={0.65}
                  >
                    <Typography
                      textTransform="uppercase"
                      variant="displayXSBold"
                      color="primary"
                    >
                      {project.title}
                    </Typography>

                    <Button
                      href={project.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ padding: 0, borderRadius: "22px 22px 0 0" }}
                    >
                      <img
                        style={{ borderRadius: "22px 22px 0 0" }}
                        src={project.caseStudyImage}
                        alt={project.title}
                        width={"100%"}
                        loading="lazy"
                        decoding="async"
                      />
                    </Button>
                  </Stack>

                  <Stack
                    justifyContent={"start"}
                    alignItems={"stretch"}
                    direction={{
                      xs: "column",
                      md: "row",
                    }}
                    height={"100%"}
                    flex={1}
                    gap={0}
                  >
                    <SquaredBox
                      $color={theme.palette.primary.main}
                      component="div"
                      flex={1}
                    >
                      <Stack
                        justifyContent="center"
                        sx={{ height: "100%" }}
                        alignItems="center"
                        direction="row"
                      >
                        <img
                          src={project.logo}
                          width={"100%"}
                          alt={`${project.title} logo`}
                          loading="lazy"
                          decoding="async"
                        />
                      </Stack>
                    </SquaredBox>

                    <SquaredBox
                      $color={theme.palette.primary.main}
                      justifyContent="center"
                      alignItems="center"
                      component="div"
                      $hideLeftBorder
                      flex={4}
                    >
                      <Stack
                        justifyContent="center"
                        sx={{ height: "100%" }}
                        alignItems="center"
                        direction="row"
                      >
                        <Typography
                          color={theme.palette.primary.main}
                          fontWeight={300}
                          variant="body1"
                        >
                          {project.description}
                        </Typography>
                      </Stack>
                    </SquaredBox>
                  </Stack>

                  <Stack
                    justifyContent={"start"}
                    alignItems={"stretch"}
                    direction={{
                      xs: "column",
                      sm: "column",
                      md: "row",
                    }}
                    bgcolor={theme.palette.tan.main}
                    mt={{
                      xs: "-0.075rem",
                      sm: "-0.075rem",
                      md: 0,
                    }}
                    height={"100%"}
                    width={"100%"}
                    flex={1}
                    gap={0}
                  >
                    <SquaredBox
                      $color={theme.palette.primary.main}
                      component="div"
                      $hideTopBorder
                      flex={3}
                    >
                      <Stack
                        justifyContent={"start"}
                        alignItems={"start"}
                        direction={"column"}
                        width={"100%"}
                        height={"100%"}
                        gap={1.15}
                      >
                        <Typography
                          color={theme.palette.primary.main}
                          fontWeight={"bold"}
                          variant="h6"
                        >
                          Project Summary
                        </Typography>
                        <Stack direction="row" gap={1}>
                          {project.summaryTags.map((tag, index) => (
                            <OurWorkChip
                              key={index}
                              $theme={theme}
                              label={tag}
                              size="small"
                            />
                          ))}
                        </Stack>
                        <Typography
                          color={theme.palette.primary.main}
                          fontWeight={300}
                          variant="body1"
                        >
                          {project.summaryDescription}
                        </Typography>
                      </Stack>
                    </SquaredBox>

                    <SquaredBox
                      $color={theme.palette.primary.main}
                      component="div"
                      $hideLeftBorder
                      $hideTopBorder
                      flex={2}
                    >
                      <Stack
                        justifyContent={"start"}
                        alignItems={"start"}
                        direction={"column"}
                        width={"100%"}
                        height={"100%"}
                        gap={1.15}
                      >
                        <Typography
                          color={theme.palette.primary.main}
                          fontWeight={"bold"}
                          variant="h6"
                        >
                          Capabilities
                        </Typography>
                        <Stack direction="row" gap={1} flexWrap="wrap">
                          {project.capabilities.map((capability, index) => (
                            <OurWorkChip
                              key={index}
                              $theme={theme}
                              label={capability}
                              color="secondary"
                              $darkVariant
                              size="small"
                            />
                          ))}
                        </Stack>
                      </Stack>
                    </SquaredBox>
                  </Stack>
                </Stack>
              ))}
            </Stack>
          </Stack>
        </Container>

        <Stack
          sx={{
            px: { xs: 1, sm: 3.5, md: 0 },
          }}
        >
          <ContactCTASection
            bgcolor="pink"
            canTilt={true}
            paddingBottom={4}
            paddingTop={7}
          />
        </Stack>
      </PageSectionBG>

      <PageSectionBG
        style={{ position: "relative" }}
        bgcolor={"transparent"}
        id="how-we-work-section"
        paddingBottom={15}
        paddingTop={20}
      >
        <Container maxWidth="xl">
          <Stack
            justifyContent={"start"}
            direction={"column"}
            alignItems={"start"}
            width={"100%"}
            gap={{
              xs: 4,
              sm: 5,
              md: 7.6,
            }}
          >
            <SectionTitle
              label="005 -- Process"
              title="How we work"
              id="process"
            />

            <Stack
              justifyContent={"start"}
              direction={"column"}
              alignItems={"start"}
              sx={{
                lineHeight: 1.8,
                width: {
                  xs: "100%",
                  sm: "90%",
                  md: "45%",
                } as any,
              }}
              gap={{
                xs: 3,
                sm: 4,
                md: 4.5,
              }}
              pb={2}
            >
              {processCards.map(({ title, description }, index) => (
                <AsideCard
                  key={index}
                  flex={1}
                  showDivider
                  bgcolor="dark"
                  // animateInView
                  chipText={index > 0 ? `Phase ${index}` : "All Phases"}
                  content={[title, description]}
                  useAlternateStyle={index === 0}
                />
              ))}
              <div style={{ flex: 1 }} />
            </Stack>

            <Stack
              justifyContent={"start"}
              direction={"column"}
              alignItems={"start"}
              width={"100%"}
              gap={4}
              pt={6}
            >
              <SectionTitle
                label="006 -- Contact"
                title="Let's get started"
                id="contact"
              />
              <Stack
                justifyContent={"start"}
                direction={"column"}
                alignItems={"start"}
                sx={{
                  lineHeight: 1.8,
                  width: {
                    xs: "100%",
                    sm: "90%",
                    md: "45%",
                  },
                }}
                gap={{
                  xs: 3,
                  sm: 4,
                  md: 4.5,
                }}
                pb={2}
              >
                <HubspotForm />
              </Stack>
            </Stack>
          </Stack>
        </Container>

        <Stack
          sx={{ display: { xs: "none", sm: "none", md: "block" } }}
          justifyContent="center"
          alignItems="center"
          width="100%"
          height="100%"
        >
          <Rings />
        </Stack>
      </PageSectionBG>

      {showOldSections && (
        <>
          <CapabilitiesSection />

          <HeadlineSection
            bgcolor="dark"
            sx={{ pt: 14, pb: 14 }}
            dividerTitle="AI & LLM @ Pencil to Polish"
            title="Leading the Way in <span class='gradient capitalize'>Gen AI</span> Implementation"
            mainContent="Empowering small to medium-sized businesses with cutting-edge technology and enterprise-level results."
            ctaButtonText="Explore AI & LLM Development"
            ctaButtonLink="/"
            titleWidthOverride={{
              sm: "100%",
              md: "100%",
              lg: "45%",
              xl: "50%",
            }}
          />

          <HeadlineSection
            bgcolor="dark"
            sx={{ pb: 12 }}
            dividerTitle="Gen AI // Capabilities"
            mainContent={
              <Grid2 container width={"100%"} pt={4} spacing={6}>
                <Grid2 xs={12} sm={12} md={12} lg={6} xl={6} pb={3}>
                  <AsideCard
                    bgcolor="dark"
                    title="Custom AI Solutions"
                    content={[
                      "Tailored AI applications to meet the specific needs of your business, ensuring alignment with your goals and challenges.",
                      "We develop bespoke AI solutions designed to address your unique business challenges, from optimizing operations to enhancing customer experiences.",
                    ]}
                  />
                </Grid2>
                <Grid2 xs={12} sm={12} md={12} lg={6} xl={6} pb={3}>
                  <AsideCard
                    bgcolor="dark"
                    title="LLM Implementation"
                    content={[
                      "Integration of advanced language models for improved customer service, content generation, and data analysis.",
                      "Our expertise in LLM implementation helps you leverage advanced language models to streamline customer interactions, automate content creation, and extract valuable insights from data.",
                    ]}
                  />
                </Grid2>
                <Grid2 xs={12} sm={12} md={12} lg={6} xl={6} pb={3}>
                  <AsideCard
                    bgcolor="dark"
                    title="Automation"
                    content={[
                      "AI-driven tools to automate business processes, reducing manual workload and increasing productivity.",
                      "Our AI-powered automation solutions streamline your business processes, minimizing manual efforts and boosting overall productivity and efficiency.",
                    ]}
                  />
                </Grid2>
                <Grid2 xs={12} sm={12} md={12} lg={6} xl={6} pb={3}>
                  <AsideCard
                    bgcolor="dark"
                    title="NLP Solutions"
                    content={[
                      "Enhance interactions and data insights with advanced Natural Language Processing technologies.",
                      "Leverage our NLP solutions to improve how your business communicates and interacts, gaining deeper insights and delivering better customer experiences.",
                    ]}
                  />
                </Grid2>
              </Grid2>
            }
          />

          <HeadlineSection
            bgcolor="dark"
            sx={{ pb: 5 }}
            dividerTitle="Gen AI // Who We’ve Worked With"
            dividerButtonText="Explore AI & LLM Development"
            dividerButtonLink="/"
            mainContent={
              <>
                {/* <Grid2 spacing={3} container pt={5}>
                 {projects.map((project, index) => {
                   return (
                     <Grid2 xs={12} sm={12} md={12} lg={4} xl={4} key={index}>
                       <Stack gap={2} pb={5}>
                          <Box
                         sx={{
                             background: `rgba(200,200,200,0.5) url(${project.image}) no-repeat center center`,
                             backdropFilter: "blur(20px)",
                             backgroundSize: "cover",
                             height: "300px",
                             width: "100%",
                           }} 
                         ></Box> 

                         <Typography variant="textXLBold" color="white">
                           {project.title}
                         </Typography>
                         <Typography variant="textXLLight" color="white">
                           {project.description}
                         </Typography>
                       </Stack>
                     </Grid2>
                   );
                 })}
               </Grid2> */}
              </>
            }
          />

          <HeadlineSection
            bgcolor="dark"
            sx={{ pt: 5, pb: 15 }}
            dividerTitle="Gen AI // Who Weve Delivered For"
            mainContent={
              <Grid2 container pt={6}>
                {/* {logos.map((logo, index) => (
                  <Grid2
                    sx={{ textAlign: "center" }}
                    justifyContent={"center"}
                    alignContent={"center"}
                    key={index}
                    xs={12}
                    sm={6}
                    md={4}
                    lg={4}
                    xl={4}
                  >
                    <img
                      src={logo.image}
                      alt={logo.alt}
                      style={{
                        filter: "brightness(10) grayscale(10)",
                        objectFit: "cover",
                        minHeight: "120px",
                      }}
                    />
                  </Grid2>
                ))} */}
              </Grid2>
            }
          />

          <WhyChooseUsSection
            bgcolor="light"
            sx={{ pt: 15, pb: 10 }}
            dividerTitle="Why choose us?"
            dividerButtonText="Get Started"
            dividerButtonLink="/"
            mainContent={
              <Stack direction={"column"} gap={2} pb={5}>
                <Typography
                  sx={{
                    typography: {
                      xs: "h4",
                      sm: "h3",
                      md: "h4",
                      lg: "textXLLight",
                    },
                    fontWeight: {
                      xs: "200",
                      sm: "200",
                      md: "300",
                      lg: "300",
                    },
                    maxWidth: {
                      sm: "100%",
                      md: "100%",
                      lg: "45%",
                      xl: "45%",
                    },
                  }}
                >
                  Trust us for reliable, cutting-edge solutions that elevate
                  your business and set you apart from the competition.
                </Typography>

                <Grid2 container width={"100%"} pt={4} spacing={6}>
                  <Grid2 xs={12} sm={12} md={12} lg={6} xl={6} pb={3}>
                    <AsideCard
                      content={[
                        "AI and LLM Solutions",
                        "We specialize in leveraging advanced AI and Large Language Models to create intelligent, scalable solutions tailored for small to medium-sized businesses.",
                      ]}
                    />
                  </Grid2>
                  <Grid2 xs={12} sm={12} md={12} lg={6} xl={6} pb={3}>
                    <AsideCard
                      content={[
                        "Comprehensive Capabilities",
                        "Our diverse range of capabilities, from product design to full-stack development, ensures that we can meet all your digital needs with precision and excellence.",
                      ]}
                    />
                  </Grid2>
                  <Grid2 xs={12} sm={12} md={12} lg={6} xl={6} pb={3}>
                    <AsideCard
                      content={[
                        "Proven Expertise and Confidentiality",
                        "With a track record of delivering high-impact projects under strict NDAs, we guarantee professionalism, confidentiality, and outstanding results.",
                      ]}
                    />
                  </Grid2>
                  <Grid2 xs={12} sm={12} md={12} lg={6} xl={6} pb={3}>
                    <AsideCard
                      content={[
                        "Client-Centric Approach",
                        "Our client-focused methodology ensures that every solution is customized to meet your unique business needs, driving exceptional outcomes and long-term success.",
                      ]}
                    />
                  </Grid2>
                </Grid2>
              </Stack>
            }
          />

          <TestimonialsSection />

          <OurWorkSection />
        </>
      )}

      <Footer />
    </PageShell>
  );
};

export default OnePager;

const WhyChooseUsSection = styled(HeadlineSection)`
  .divider {
    margin-bottom: 0.75rem;

    .divider-title {
      text-transform: uppercase;
      position: relative;
      line-height: 1rem;
      font-size: 3rem;
      top: 0.2rem;
    }
  }
`;

const SquaredBox = styled(Box)<{
  $color?: string;
  $hideLeftBorder?: boolean;
  $hideTopBorder?: boolean;
}>`
  border: 1px solid ${({ $color }) => $color};
  border-left: ${({ $hideLeftBorder, $color }) =>
    $hideLeftBorder ? "none" : `1px solid ${$color}`};
  border-top: ${({ $hideTopBorder, $color }) =>
    $hideTopBorder ? "none" : `1px solid ${$color}`};
  border-radius: 0px;
  padding: 1rem;

  @media (max-width: 600px) {
    padding: 0.75rem;

    // Reset borders for mobile stacked layout
    border: 1px solid ${({ $color }) => $color};
    &:not(:first-child) {
      border-top: none;
    }
  }
`;

const OurWorkChip = styled(Chip)<{ $theme: Theme; $darkVariant?: boolean }>`
  &.MuiChip-root {
    background: ${({ $darkVariant, $theme }) =>
      $darkVariant ? `${$theme.palette.primary.main}30` : "#ffcc00"};
    border: 0.075rem solid ${({ $theme }) => $theme.palette.primary.main};
    color: ${({ $theme }) => $theme.palette.primary.main};
    text-transform: uppercase;
    border-radius: 3px;
    font-size: 0.9rem;
    padding: 0.2rem;
    height: 2rem;

    @media (max-width: 600px) {
      font-size: 0.8rem;
      height: 1.75rem;
      padding: 0.15rem;
    }
  }
`;
